import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNoteText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNoteText"><Path d="M3.5 3.5H20.5V16L16 20.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 8.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 12.5H11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 20V15.5H20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconNoteText;
